import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import { createAuth0 } from "@auth0/auth0-vue";
//import { domain, clientId as client_id } from "../auth_config.json";

//const domain = "auth.dev.spectee.com";
//const client_id = "44aHZiPbOLJGZWy3bHybA5485Ur3lbfp";
const domain = "auth.spectee.com";
const client_id = "dlY5IrANiHBgV6shLK4TIxrfcR2FaSUC";
const auth = createAuth0({
  domain,
  client_id,
  redirect_uri: window.location.origin,
});

createApp(App).use(router).use(auth).mount("#app");
